import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import classnames from '../../../node_modules/classnames/index.js';
import { styled, useThemeProps } from '@mui/material';
import TwoButtonModal from '../base/TwoButtonModal.js';
import { createComponentSlot } from '../../../modules/styling/theme.js';

var _templateObject;

var _excluded = ["className"];
var componentRoot = createComponentSlot({
  name: "CinModalEdit",
  slot: "Root"
});

var EditModalBase = function EditModalBase(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(TwoButtonModal, _extends({}, props, {
    className: classnames(componentRoot.className, className)
  }));
};

var EditModalRoot = styled(EditModalBase, componentRoot.styledOptions)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
EditModalRoot.defaultProps = {
  header: "Edit",
  submitLabel: "Update",
  cancelLabel: "Cancel",
  onSubmit: function onSubmit() {},
  onCancel: function onCancel() {},
  size: "md"
};
/**
 * A modal template for performing an edit operation
 */

var EditModal = function EditModal(props) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(EditModalRoot, rootProps);
};

var EditModal$1 = EditModal;

export { EditModal$1 as default };
